var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "custom-modal",
      attrs: {
        name: "manageEmailModal",
        id: "manageEmailModal",
        width: "75%",
        height: "auto",
        scrollable: true,
        pivotX: 1.0,
        minWidth: 900,
        minHeight: 900,
        clickToClose: true
      },
      on: {
        "before-open": _vm.beforeOpen,
        "before-close": _vm.beforeClose,
        opened: _vm.opened
      }
    },
    [
      _c(
        "div",
        { staticClass: "client-contact-email-page" },
        [
          _c("div", { staticClass: "header-email-page" }, [
            _c("p", [_vm._v("Email Client")]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon-close",
              on: {
                click: function($event) {
                  _vm.cancelClick()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("ClientContactEmail", {
                attrs: {
                  eventId: _vm.eventId,
                  event: _vm.event,
                  singleEvent: _vm.singleEvent,
                  isChange: _vm.isChange,
                  emailTemplateType: _vm.emailTemplateType,
                  replyEmail: _vm.replyEmail,
                  listEmailCC: _vm.listEmailCC,
                  listEmailSendTo: _vm.listEmailSendTo,
                  body: _vm.body,
                  cancelClick: _vm.cancelClick,
                  backToPreviousPage: _vm.backToPreviousPage
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("ModalInfo", {
            on: { CLOSE_MODAL_INFO: _vm.closeModalCancelEmail }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eb29f698", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb29f698","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/email/ManageEmail.vue
// module id = 1683
// module chunks = 1